export class themeColorConfig {
   navBarColor = "white";
   navBarTextColor = "white"
                           
}